const supragtrData = {
  slug: "supra-gtr-150",
  name: "Honda Supra GTR 150",

  hero: {
    shortDescription:
      "Motor sport underbone 150cc dengan performa tinggi, desain agresif, dan handling stabil",

    variants: [
      {
        key: "sporty-spartan-red",
        label: "Sporty",
        fullName: "Honda Supra GTR 150 Sporty Spartan Red",
        startPrice: 26909000,
      },
      {
        key: "sporty-gun-black",
        label: "Sporty",
        fullName: "Honda Supra GTR 150 Sporty Gun Black",
        startPrice: 26909000,
      },
      {
        key: "exclusive-matte-red",
        label: "Exclusive",
        fullName: "Honda Supra GTR 150 Exclusive Matte Red",
        startPrice: 27159000,
      },
    ],

    slides: [
      {
        variantKey: "sporty-spartan-red",
        image: "/assets/motor/produk/suptragtr/Honda-Supra-GTR-150-Sporty-Spartan-Red.webp",
        specs: {
          engine: "149,16 cc",
          transmission: "Manual 6 Percepatan",
          feature: "DOHC",
        },
      },
      {
        variantKey: "sporty-gun-black",
        image: "/assets/motor/produk/suptragtr/Honda-Supra-GTR-150-Sporty-Gun-Black.webp",
        specs: {
          engine: "149,16 cc",
          transmission: "Manual 6 Percepatan",
          feature: "DOHC",
        },
      },
      {
        variantKey: "exclusive-matte-red",
        image: "/assets/motor/produk/suptragtr/Honda-Supra-GTR-150-Exclusive-Matte-Red.webp",
        specs: {
          engine: "149,16 cc",
          transmission: "Manual 6 Percepatan",
          feature: "DOHC",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Supra GTR 150 hadir sebagai motor sport underbone dengan desain agresif dan performa tinggi.",
      },
      {
        type: "paragraph",
        text:
          "Ditenagai mesin 150cc DOHC 4 katup, Supra GTR 150 menawarkan akselerasi responsif dan tenaga optimal.",
      },
      {
        type: "heading",
        text: "Performa Balap Harian",
      },
      {
        type: "paragraph",
        text:
          "Transmisi manual 6 percepatan memberikan kontrol penuh untuk berkendara di berbagai kondisi.",
      },
      {
        type: "heading",
        text: "Stabil & Presisi",
      },
      {
        type: "paragraph",
        text:
          "Rangka backbone dan suspensi berkualitas memastikan kestabilan saat bermanuver dan kecepatan tinggi.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, DOHC, 4 Katup"],
      ["Kapasitas Mesin", "149,16 cc"],
      ["Sistem Pendingin", "Liquid Cooled"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "12,4 kW / 9.000 rpm"],
      ["Torsi Maksimum", "14,2 Nm / 6.500 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Backbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Monoshock"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "2.025 x 705 x 1.103 mm"],
      ["Jarak Sumbu Roda", "1.284 mm"],
      ["Tinggi Jok", "787 mm"],
      ["Berat", "119 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,5 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Full Digital"],
      ["Lampu", "Full LED"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Supra GTR 150",
    items: [
      {
        title: "Mesin 150cc DOHC",
        desc:
          "Tenaga responsif dengan performa tinggi untuk penggunaan harian dan sport riding.",
      },
      {
        title: "Transmisi 6 Percepatan",
        desc:
          "Perpindahan gigi halus dan presisi untuk akselerasi maksimal.",
      },
      {
        title: "Full Digital Panel Meter",
        desc:
          "Tampilan modern dengan informasi lengkap.",
      },
      {
        title: "Full LED Lighting",
        desc:
          "Pencahayaan terang, hemat energi, dan futuristik.",
      },
      {
        title: "Suspensi Monoshock",
        desc:
          "Stabil dan nyaman di berbagai kondisi jalan.",
      },
      {
        title: "Rem Cakram Depan & Belakang",
        desc:
          "Pengereman lebih optimal dan aman.",
      },
    ],
  },
};

export default supragtrData;
